import * as React from "react"
import { SVGProps } from "react"

export const CancelIcon = ({ fill = "#444", ...props }: SVGProps<SVGSVGElement> & { fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M.343 14.678c.1.105.224.188.362.243.139.056.288.083.438.079.15.004.3-.023.438-.079.138-.055.262-.138.362-.243L8 8.992l6.057 5.686c.103.102.227.183.365.238a1.166 1.166 0 0 0 1.235-.238 1.04 1.04 0 0 0 .254-.343.982.982 0 0 0 0-.817 1.039 1.039 0 0 0-.254-.342L9.6 7.491l6.057-5.686c.208-.2.325-.469.323-.748A1.03 1.03 0 0 0 15.65.31 1.17 1.17 0 0 0 14.855 0a1.171 1.171 0 0 0-.798.304L8 5.989 1.943.304A1.171 1.171 0 0 0 1.146 0 1.17 1.17 0 0 0 .35.311a1.03 1.03 0 0 0-.331.746c-.002.28.115.548.323.748L6.4 7.491.343 13.176a1.038 1.038 0 0 0-.254.342.982.982 0 0 0 0 .817c.06.13.146.246.254.343Z"
      clipRule="evenodd"
    />
  </svg>
)
